import React from 'react';
import { environment } from '../../util/baseUrl';

const TicketVenta = ({ venta, empresa, detalles, cliente, esReimpresion }) => {
    // Helper para formatear moneda
    const formatCurrency = (val) => {
        return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(val || 0);
    };

    // Helper para formatear fecha
    const formatDateTime = (dateString) => {
        if (!dateString) return new Date().toLocaleString('es-PE');
        return new Date(dateString).toLocaleString('es-PE');
    };

    const logoUrl = empresa?.logo ? `${environment.backendUrl}${empresa.logo}` : null;

    return (
        <div id="printable-ticket" className="ticket-printable">
            {/* Cabecera del Ticket */}
            <div className="ticket-header">
                {logoUrl ? (
                    <img src={logoUrl} alt="Logo" className="ticket-logo" />
                ) : (
                    <h2 className="ticket-company-name">{empresa?.nombreComercial || empresa?.nombre || 'Mi Empresa'}</h2>
                )}
                <div className="ticket-company-info">
                    {empresa?.ruc && <p>RUC: {empresa.ruc}</p>}
                    {empresa?.direccion && <p>{empresa.direccion}</p>}
                    {(empresa?.telefono || empresa?.email) && (
                        <p>{empresa?.telefono} {empresa?.email ? `- ${empresa.email}` : ''}</p>
                    )}
                </div>
            </div>

            <div className="ticket-divider">================================</div>

            {/* Título de Documento y Metadatos */}
            <div className="ticket-meta">
                <h3 className="ticket-title">
                    {venta?.tipoComprobante?.toUpperCase() || 'TICKET DE VENTA'}
                </h3>
                {esReimpresion && <h4 className="ticket-reimpresion">*** RE-IMPRESIÓN ***</h4>}
                
                <div className="ticket-meta-grid">
                    <div className="meta-row">
                        <span>Ticket:</span>
                        <span>{venta?.codigoVenta || 'N/A'}</span>
                    </div>
                    <div className="meta-row">
                        <span>Fecha:</span>
                        <span>{formatDateTime(venta?.fechaCreacion)}</span>
                    </div>
                    {venta?.idUsuario && (
                        <div className="meta-row">
                            <span>Cajero:</span>
                            <span>{venta?.idUsuario}</span>
                        </div>
                    )}
                </div>
            </div>

            <div className="ticket-divider">--------------------------------</div>

            {/* Datos del Cliente */}
            <div className="ticket-customer">
                <div className="meta-row">
                    <span>Cliente:</span>
                    <span className="text-right">
                        {cliente?.nombre || cliente?.razonSocial || 
                         `${cliente?.nombres || ''} ${cliente?.apellidoPaterno || ''}`.trim() || 'Público General'}
                    </span>
                </div>
                {cliente?.numeroDocumento && (
                    <div className="meta-row">
                        <span>{cliente?.tipoDocumento || 'DOC'}:</span>
                        <span className="text-right">{cliente.numeroDocumento}</span>
                    </div>
                )}
            </div>

            <div className="ticket-divider">================================</div>

            {/* Productos */}
            <div className="ticket-items">
                <table className="ticket-table">
                    <thead>
                        <tr>
                            <th className="col-qty">Cant</th>
                            <th className="col-desc">Descripción</th>
                            <th className="col-price">Precio</th>
                            <th className="col-total">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {detalles?.map((item, idx) => (
                            <tr key={idx}>
                                <td className="col-qty">{item.cantidad}</td>
                                <td className="col-desc">
                                    {item.variante?.displayName || item.nombreVariante || item.nombre}
                                </td>
                                <td className="col-price">{formatCurrency(item.precio || item.precioUnitario)}</td>
                                <td className="col-total">{formatCurrency((item.cantidad * (item.precio || item.precioUnitario)))}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="ticket-divider">--------------------------------</div>

            {/* Totales */}
            <div className="ticket-totals">
                {venta?.subTotal > 0 && (
                    <div className="meta-row">
                        <span>OP. GRAVADA:</span>
                        <span>{formatCurrency(venta.subTotal)}</span>
                    </div>
                )}
                {venta?.totalImpuestos > 0 && (
                    <div className="meta-row">
                        <span>IGV (18%):</span>
                        <span>{formatCurrency(venta.totalImpuestos)}</span>
                    </div>
                )}
                <div className="meta-row total-row">
                    <span>TOTAL A PAGAR:</span>
                    <span>{formatCurrency(venta?.montoTotal || 0)}</span>
                </div>
            </div>

            <div className="ticket-divider">================================</div>

            {/* Forma de Pago */}
            <div className="ticket-payments">
                <div className="meta-row pb-1">
                    <span>MÉTODO PAGO:</span>
                    <span>{venta?.tipoDePago || 'EFECTIVO'}</span>
                </div>
                {venta?.tipoDePago === 'Efectivo' && venta?.pagoCon > 0 && (
                    <>
                        <div className="meta-row pb-1">
                            <span>PAGO CON:</span>
                            <span>{formatCurrency(venta.pagoCon)}</span>
                        </div>
                        <div className="meta-row pb-1">
                            <span>VUELTO:</span>
                            <span>{formatCurrency(venta.vuelto || 0)}</span>
                        </div>
                    </>
                )}
            </div>

            <div className="ticket-divider">================================</div>

            {/* Footer Mensaje */}
            <div className="ticket-footer">
                <p className="ticket-thanks">¡Gracias por su compra!</p>
                <div className="ticket-barcode">
                    {/* Simulación visual de código de barras usando font simple */}
                    <span className="barcode-font">* {venta?.codigoVenta?.replace('-', '') || '000000'} *</span>
                </div>
                <p className="ticket-tech">SISTEMA VENTAS - POS</p>
            </div>
        </div>
    );
};

export default TicketVenta;
